// Remove Emergent badge
(function() {
  'use strict';
  
  function removeBadge() {
    const badge = document.getElementById('emergent-badge');
    if (badge) {
      badge.style.display = 'none';
      badge.style.visibility = 'hidden';
      badge.style.opacity = '0';
      badge.remove();
    }
  }
  
  // Remove on load
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', removeBadge);
  } else {
    removeBadge();
  }
  
  // Watch for badge being added dynamically
  const observer = new MutationObserver(function(mutations) {
    removeBadge();
  });
  
  observer.observe(document.body, {
    childList: true,
    subtree: true
  });
  
  // Also check periodically
  setInterval(removeBadge, 100);
})();